import axios from 'axios'
import Cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode';
const ENV = window.env
const API_BASE_URL = ENV.BASE_URL_BACKEND +`/auth`
const CLIENT_ID = ENV.CLIENT_ID
const CLIENT_SECRET = ENV.CLIENT_SECRET
const ACCESS_TOKEN_COOKIE_NAME = 'accessToken'
const REFRESH_TOKEN_COOKIE_NAME = 'refreshToken'
const axiosInstance = axios.create()

export const authService = {
  generateToken: async () => {
    try {
      const response = await axiosInstance.post(`${API_BASE_URL}/token`, {
        clientId: CLIENT_ID,
        clientSecret: CLIENT_SECRET,
      })

      const { accessToken, refreshToken } = response.data.data
      Cookies.set(ACCESS_TOKEN_COOKIE_NAME, accessToken, { expires: 1 })
      Cookies.set(REFRESH_TOKEN_COOKIE_NAME, refreshToken, { expires: 7 })
      return { accessToken, refreshToken }
    } catch (error) {
      console.error('Error generating token:', error)
      throw error
    }
  },

  refreshToken: async () => {
    try {
      const refreshToken = Cookies.get(REFRESH_TOKEN_COOKIE_NAME)
  
      if (!refreshToken) {
        authService.removeToken()
        window.location.replace('/error')
        throw new Error('No refresh token found.')
      }
  
      const response = await axiosInstance.post(`${API_BASE_URL}/refresh`, { refreshToken })
      
      const { accessToken } = response.data.data 
  
      if (!accessToken) {
        throw new Error('No access token received during refresh.')
      }
  
      // ✅ อัปเดต AccessToken ใหม่, ใช้ RefreshToken ตัวเดิมต่อไป
      Cookies.set(ACCESS_TOKEN_COOKIE_NAME, accessToken, { expires: 1 }) 
      
      console.log('Token refreshed successfully:', accessToken)
  
      return { accessToken, refreshToken }
    } catch (error) {
      console.error('Error refreshing token:', error)
      authService.removeToken()
      window.location.replace('/error')
      throw error
    }
  },

  testAuth: async () => {
    try {
      const accessToken = Cookies.get(ACCESS_TOKEN_COOKIE_NAME)
      if (!accessToken) {
        throw new Error('No access token found.')
      }
      const response = await axiosInstance.get(`${API_BASE_URL}/test`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      return response.data
    } catch (error) {
      console.error('Error testing auth:', error)
      throw error
    }
  },

  getAccessToken: () => {
    return Cookies.get(ACCESS_TOKEN_COOKIE_NAME)
  },
  getRefreshToken: () => {
    return Cookies.get(REFRESH_TOKEN_COOKIE_NAME)
  },
  isTokenExpired: (token) => {
    if (!token) return true
    try {
      const decoded = jwtDecode(token)
      return decoded.exp * 1000 < Date.now()
    } catch (error) {
      console.error('Error decoding token:', error)
      return true
    }
  },
  removeToken: () => {
    Cookies.remove(ACCESS_TOKEN_COOKIE_NAME)
    Cookies.remove(REFRESH_TOKEN_COOKIE_NAME)
  },

  //setup middleware
  setupInterceptors: () => {
    axiosInstance.interceptors.request.use(
      (config) => {
        const accessToken = authService.getAccessToken()
        if (accessToken) {
          config.headers['Authorization'] = `Bearer ${accessToken}`
        }
        return config
      },
      (error) => Promise.reject(error)
    )

    axiosInstance.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error.config
        if (error.response?.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true
          const refreshToken = authService.getRefreshToken()
          if (!refreshToken || authService.isTokenExpired(refreshToken)) {
            authService.removeToken()
            window.location.replace('/error')
            return Promise.reject(error)
          }
          try {
            await authService.refreshToken()
            const newAccessToken = authService.getAccessToken()
            if (newAccessToken) {
              originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`
              return axiosInstance(originalRequest)
            }
          } catch (refreshError) {
            console.error('Error refreshing token:', refreshError)
            authService.removeToken()
            window.location.replace('/error')
            return Promise.reject(refreshError)
          }
        }
        return Promise.reject(error)
      }
    )
  },
}
